import React, { useState } from "react"
import { Link, useHistory } from "react-router-dom"
import { Col, Row } from "reactstrap"
import toast from "react-hot-toast"

import settingsIcon from "../../../assets/images/icons/settings-icon.svg"
import editIcon from "../../../assets/images/icons/edit-icon.svg"
import DeleteIcon from "assets/images/icons/finance-vendor-mang-del-icon.svg"

import { DataTable } from "../../../components/DataTable"
import { useLocalPaginatedRequest } from "../../../hooks/useLocalPaginatedRequest"
import { Button } from "../../../components/Button"
import { SearchBox } from "../../../components/SearchBox"
import { AutoComplete } from "../../../components/AutoComplete"
import ActiveInactiveSwitch from "../../Configurator/CommonUI/ActiveInactiveSwitch/ActiveInactiveSwitch"
import autoCompleteStyles from "../../../components/AutoComplete/autoCompleteStyles"
import {
   DeleteBaseFeatureCategory,
   GetBaseFeaturesCategoriesListing,
   UpdateBaseFeatureCategory,
   UpdateGlobalBaseFeatureCategorySequence,
} from "../../../api/api.service"
import {
   ConfiguratorBaseFeaturesCategoryStatus,
   SortOrder,
} from "../../../constants"
import {
   convertToSelectOptions,
   replaceSlashes,
} from "../../../utils/commonUtils"
import DeleteModal from "../../Configurator/CommonUI/Modal/DeleteModal"
import { convertDateTime, dateTimeFormat } from "utils/dateFormatUtils"
import { APP_ROUTES, getRoute } from "../../../helpers/routeHelpers"
import ManageBaseFeaturesModal from "./ManageBaseFeaturesModal"
import { Pagination } from "../../../components/Pagination"
import useRenderUsedIn from "hooks/useRenderUsedIn"
import TruncatedTextWithTooltip from "components/CustomTooltip/CustomTooltip"
import { DragDropContext, Droppable } from "react-beautiful-dnd"

const COLUMNS = {
   FEATURE_NAME: "Feature Name",
   DATE_EDITED: "Date Edited",
   NO_OF_ITEMS: "No. of Items",
   USED_IN: "Used In",
   STATUS: "Status",
   ACTION: "Action",
}
const DATA_KEY = "data"
const TOTAL_KEY = "total"
const INFINITE_LIMIT_COUNT = -1

const GlobalBaseFeatures = () => {
   const history = useHistory()
   const [selection, setSelection] = useState({})
   const [openDelModal, setOpenDelModal] = useState(false)
   const [statusFilters, setStatusFilters] = useState(null)
   const [eventsType, setEventsType] = useState({
      isManage: null,
      isUpdate: null,
      isDetails: null,
   })

   const {
      data,
      isFetching,
      page,
      pageSize,
      total,
      searchText,
      handleSearchChange,
      handlePageClick,
      onChangePageSize,
      request,
      setData,
      setTableDataChangeLoading,
      tableDataChangeLoading,
   } = useLocalPaginatedRequest({
      requestFn: GetBaseFeaturesCategoriesListing,
      params: {
         page: 1,
         limit: INFINITE_LIMIT_COUNT,
         direction: SortOrder.ASC,
         column: "sequenceNo",
         ...(statusFilters?.value && { status: statusFilters?.value }),
      },
      deps: [statusFilters],
      dataKey: DATA_KEY,
      totalKey: TOTAL_KEY,
   })
   const renderUsedIn = useRenderUsedIn({
      listKey: "trailers",
   })

   const handleInitManage = obj => {
      setSelection(obj)
      setEventsType(prev => ({ ...prev, isManage: true }))
   }

   const handleInitDelete = obj => {
      setSelection(obj)
      setOpenDelModal(prev => !prev)
   }

   const handleSelectStatusOption = option => {
      setStatusFilters(option)
   }

   const handleNavigateToSettings = obj => {
      setSelection(obj)
      return history.push(
         getRoute(
            APP_ROUTES.CONFIGURATOR_TRAILER_SETTINGS_GLOBAL_BASE_FEATURES_ITEMS,
            {
               categoryId: obj.id,
               categoryName: replaceSlashes(obj.name),
            }
         )
      )
   }

   const handleStatusChange = async (currStatus, id) => {
      const status =
         currStatus === ConfiguratorBaseFeaturesCategoryStatus.Active
            ? ConfiguratorBaseFeaturesCategoryStatus.Inactive
            : ConfiguratorBaseFeaturesCategoryStatus.Active
      const dataClone = [...data]
      dataClone.forEach(el => {
         if (el?.id == id) {
            el.status = status
         }
      })
      setData(dataClone)
      const payload = {
         status: status,
      }
      try {
         setTableDataChangeLoading(true)
         await UpdateBaseFeatureCategory(id, payload)
         toast.success("Category status has been updated!")
      } catch (err) {
         toast.error(err.message)
         const dataClone = [...data]
         dataClone.forEach(el => {
            if (el?.id == id) {
               el.status = currStatus
            }
         })
         setData(dataClone)
      } finally {
         setTableDataChangeLoading(false)
      }
   }

   const handleDragEnd = async result => {
      if (!result.destination) return

      const items = Array.from(data)
      const [reorderedItem] = items.splice(result.source.index, 1)
      items.splice(result.destination.index, 0, reorderedItem)

      setData(items)

      let payload = {
         sequenceItems: items.map((trailerObj, ind) => ({
            id: Number(trailerObj.id),
            sequenceNo: ind,
         })),
      }

      try {
         await UpdateGlobalBaseFeatureCategorySequence(payload)
         toast.success("Sequence updated successfully!")
      } catch (err) {
         toast.error("Failed to update sequence")
      }
   }

   return (
      <>
         <Link to={APP_ROUTES.CONFIGURATOR_TRAILERS}>
            <div className="d-flex align-items-center gap-2  configurator-top-link">
               <span className="configurator-global-arrow">&lt;</span>{" "}
               Configurator Settings
            </div>
         </Link>

         <div className="mb-3 trailer-container px-2">
            <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness trailer-btn-container">
               <h3 className="configurator-global-heading">Base Feature</h3>
               <div />
               <Button
                  className={`header-button headerButtonResponsive`}
                  title="Add Feature"
                  onClick={() => handleInitManage({})}
               />
            </div>
         </div>

         <div className="mb-3 px-2">
            <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness">
               <div className="status-search-con wh-im-dpgi-status me-2">
                  <AutoComplete
                     value={statusFilters}
                     isClearable
                     onChange={val => handleSelectStatusOption(val)}
                     isSearchable={false}
                     placeholder="Select status"
                     customStyles={autoCompleteStyles.STYLE_SIX}
                     classNamePrefix="status-header-search-admin"
                     options={convertToSelectOptions(
                        ConfiguratorBaseFeaturesCategoryStatus
                     )}
                  />
               </div>
               <div className="ad-location-search-box">
                  <SearchBox
                     inputClasses="vendor-search-input input-search"
                     labelClass="d-none"
                     placeholder="Search"
                     searchIcon={true}
                     searchIconClass="vendor-table-search-icon"
                     conClass="vendor-table-search-inner-class"
                     searchText={searchText}
                     onChange={handleSearchChange}
                  />
               </div>
            </div>
         </div>

         <Row>
            <Col md={12}>
               <DragDropContext onDragEnd={handleDragEnd}>
                  <Droppable droppableId="droppable">
                     {provided => (
                        <div
                           {...provided.droppableProps}
                           ref={provided.innerRef}
                        >
                           <DataTable
                              data={data}
                              isDraggable={true}
                              droppablePlaceholder={provided.placeholder}
                              tableClasses="base-feature-table"
                              loading={isFetching}
                              config={[
                                 {
                                    title: COLUMNS.FEATURE_NAME,
                                    className: "w-25",
                                    render: row => {
                                       return (
                                          <TruncatedTextWithTooltip
                                             text={row.name}
                                          />
                                       )
                                    },
                                 },
                                 {
                                    title: COLUMNS.DATE_EDITED,
                                    className: "w-20",
                                    render: row =>
                                       convertDateTime({
                                          date: row?.updatedAt,
                                          customFormat:
                                             dateTimeFormat.casitaCustomDateFormat,
                                          dateOnly: true,
                                          local: true,
                                       }),
                                 },
                                 {
                                    title: COLUMNS.NO_OF_ITEMS,
                                    render: row => (
                                       <span className="text-primary ">
                                          {row?.totalItems ?? 0}
                                       </span>
                                    ),
                                 },
                                 {
                                    title: COLUMNS.USED_IN,
                                    render: renderUsedIn,
                                 },
                                 {
                                    title: COLUMNS.STATUS,
                                    render: row => (
                                       <ActiveInactiveSwitch
                                          isDisable={tableDataChangeLoading}
                                          id={row.id}
                                          name={`${row.id}`}
                                          onChange={e =>
                                             handleStatusChange(
                                                row?.status,
                                                row?.id
                                             )
                                          }
                                          isChecked={
                                             row?.status ===
                                             ConfiguratorBaseFeaturesCategoryStatus.Active
                                          }
                                       />
                                    ),
                                 },
                                 {
                                    title: COLUMNS.ACTION,
                                    render: row => (
                                       <div className="d-flex gap-2 pointer">
                                          <img
                                             src={editIcon}
                                             onClick={() =>
                                                handleInitManage(row)
                                             }
                                          />
                                          <img
                                             src={settingsIcon}
                                             onClick={() =>
                                                handleNavigateToSettings(row)
                                             }
                                          />
                                          <img
                                             src={DeleteIcon}
                                             onClick={() =>
                                                handleInitDelete(row)
                                             }
                                          />
                                       </div>
                                    ),
                                 },
                              ]}
                           />
                        </div>
                     )}
                  </Droppable>
               </DragDropContext>

               {/* <Pagination
                  currentPage={page}
                  totalData={total}
                  onPageClick={handlePageClick}
                  rowLimit={pageSize}
                  onChangePageSize={onChangePageSize}
               /> */}
            </Col>
         </Row>

         <ManageBaseFeaturesModal
            isOpen={eventsType.isManage}
            onToggleModal={() => {
               setSelection({})
               setEventsType(prev => ({
                  ...prev,
                  isManage: false,
               }))
            }}
            onSuccess={request}
            id={selection?.id}
         />

         <DeleteModal
            isOpen={openDelModal}
            toggleFunction={setOpenDelModal}
            id={selection.id}
            apiFunction={DeleteBaseFeatureCategory}
            title={"Base Feature"}
            requestFunction={request}
         />
      </>
   )
}

export default GlobalBaseFeatures
